<!--
Author:
Create Time: 2020-04-13 09:22:08
Description: 设备档案
-->
<template>
  <div class="com-proDevice-select">
      <span>
          <el-input
            placeholder
            v-model="label"
            @focus="handleInputClick"
            :disabled="disabled"
            data-ignore-clearable="true"
            data-ignore-at-clear="handleClear"
            :title="label"
          ></el-input>
      </span>

      <proDeviceRegisterRef
        ref="proDeviceRegisterRef"
        :visible="isproRewardPunishRegisterRefVisible"
        @confirm="handleproRewardPunishRegisterRefConfirm"
        :multiple="multiple"
        @cancel="handleproRewardPunishRegisterRefCancel"
        append-to-body
        width="65%"
      />
  </div>
</template>

<script>
export default {
  name: 'proDeviceRegisterSelect',
  props: {
      value: {
          type: [String, Array, undefined],
          default: () => ''
      },
      label: {
          type: String,
          default: () => ''
      },
      disabled: {
          type: Boolean,
          default: () => false
      },
  },
  data () {
    return {
        isproRewardPunishRegisterRefVisible: false,
    }
  },
  computed: {
      multiple() {
          return Array.isArray(this.value);
      },
  },
  methods: {
      handleInputClick() {
          this.isproRewardPunishRegisterRefVisible = true;
      },
      handleClear() {},
      handleproRewardPunishRegisterRefConfirm(value) {
          let val = Array.isArray(value) ? value.map(o => o.id) : value.id;
          this.$emit('update:value', val, value);
          this.$emit('change', val, value);
          this.$emit('input', val, value);
          this.isproRewardPunishRegisterRefVisible = false;
      },
      handleproRewardPunishRegisterRefCancel() {
          this.isproRewardPunishRegisterRefVisible = false;
      },
  }
}
</script>

<style scoped lang="less">
.com-proDevice-select {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/proDeviceRegister/proDeviceRegisterSelect.vue